import React from 'react'
import { AuthorBlock } from '../blog/BlogList'
import { BlogPost } from '../blog/BlogTypes'
import Image from 'next/image'
import Wrapper from '../shared/Wrapper'
import { cropImageFromCdn } from '../../lib/fetchBlog'
import { HEADER_ADJUSTING_STYLES } from '../shared/PageHeader'

interface SinglePostHeaderProps {
  post: BlogPost
}

export default function SinglePostHeader({
  post,
}: SinglePostHeaderProps): JSX.Element {
  return (
    <div style={HEADER_ADJUSTING_STYLES} className="w-full relative text-white">
      <Wrapper className="relative z-20 py-20">
        <header className="w-full max-w-2xl">
          <h1 className="text-4xl font-medium mb-8">{post.title}</h1>
          <p className="mb-10 text-lg">{post.summary}</p>

          <AuthorBlock
            name={`${post.author?.first_name} ${post.author?.last_name}`}
            avatarUrl={post.author?.profile_image ?? ''}
            publishDateString={post.published ?? ''}
          />
        </header>
      </Wrapper>

      {post.featured_image && (
        <div className="absolute z-0 top-0 w-full bottom-0">
          <div className="z-10 absolute w-full top-0 bottom-0 bg-black bg-opacity-50" />
          <Image
            src={cropImageFromCdn(post.featured_image, 1280, 720)}
            alt={post.featured_image_alt ?? ''}
            fill
            className="object-cover object-center"
          />
        </div>
      )}
    </div>
  )
}
